import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import { Color } from "../../../../constants/V2/color"
import CategorySlide from "../../../V2/Lab/CategorySlider/CategorySlide"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const CategorySliderStoryblok = ({
  blok,
  color,
}: Storyblok.BlokProps<Storyblok.CategorySlide> & {
  color: Color.Charcoal | Color.White
}) => {
  return (
    <CategorySlide
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
      categoryHeadingText={blok.categoryHeadingText}
      headingText={blok.headingText}
      descriptionText={blok.descriptionText}
      buttonText={blok.ctaText}
      buttonUrl={storyblokLinkToYocoLink(blok.ctaLink)}
      image={blok.image?.filename}
      imageAlt={blok.image?.alt}
      color={color}
    />
  )
}

CategorySliderStoryblok.displayName = "SwiperSlide"

export default CategorySliderStoryblok
